// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slice--products.slice--products--first.slice--products--fast-links{padding-top:calc(var(--spacing)*2)}@media (min-width:48.0625em){.slice--products.slice--products--first.slice--products--fast-links{padding-top:calc(var(--spacing)*4)}}.slice--products .grid-of-products+.grid-of-products{margin-top:calc(var(--spacing)*.2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
